import { useCheckout } from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LayoutObject, StripePaymentElementOptions } from "@stripe/stripe-js";

const layout: LayoutObject = {
  type: "tabs", //accordion, tabs, or auto
  defaultCollapsed: false,
  radios: false, // Show radio buttons before payment method names
  visibleAccordionItemsCount: 4, // Number of accordion items to show by default (other items can be expanded by 'Other' button)
};

const elementOptions: StripePaymentElementOptions = {
  layout: layout,
};

export const usePaymentForm = () => {
  const { t } = useTranslation();

  const checkout = useCheckout();

  const [error, setError] = useState<string>();
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmitPayment = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();

    setError(undefined);
    setLoading(true);

    try {
      const result = await checkout.confirm();

      if (result.type === "error") {
        console.error("Payment submission error:", result.error.message);
        setError(result.error.message);
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Error during payment submission:", error);
      setShowAlert(true);
    } finally {
      setLoading(false);
    }
  };

  return {
    error,
    elementOptions,
    showAlert,
    loading,
    t,
    handleSubmitPayment,
    setShowAlert,
  };
};
